/**
 *  Module for sending analytics to omniture and google analytics
 */

const _ = require('lodash'),
  moment = require('moment'),
  $ = require('jquery');

const localStorageName = '_analyticsData',
  _showLogging = true;

const Local_Analytics = function() {

  function alphabetize(data) {
    const keys = Object.keys(data),
      len = keys.length,
      sorted = {};

    keys.sort();

    for (let i = 0; i < len; i++) {
      k = keys[i];
      sorted[k] = data[k];
    }

    return sorted;
  }

  function getItems() {
    const items = localStorage.getItem(localStorageName);
    return (items) ? JSON.parse(items) : {};
  }

  function setItem(item) {
    let items = getItems();
    const now = moment().format('x'),
      new_item = {};

    new_item[now] = item;

    items = _.merge(items, new_item);

    localStorage.setItem(localStorageName, JSON.stringify(items));

    return items;
  }

  function updateEntries() {
    const items = getItems();
    let markup = '';

    $('.fc-analytics-entries').html('');

    _.forEachRight(items, function(item) {
      markup += '<div class="fc-analytics-entry">';
      markup += '<div class="fc-analytics-event"><strong>Event:</strong> '+ item.event +'</div>';
      markup += '<div class="fc-analytics-properties"><strong>Properties:</strong> ';
      markup += '<pre>'+ JSON.stringify(item.properties, null, 2) +'</pre>';
      markup += '</div>';
      markup += '</div>';
    });

    if ( !_.size(items) ) {
      markup += '<div class="fc-analytics-empty">There are no events tracked</div>';
    }

    $('.fc-analytics-entries').html(markup);
  }

  function clearItems() {
    localStorage.removeItem(localStorageName);
    $('.fc-analytics-entries').html('');
    updateEntries();
  }

  function hideAnalytics() {
    $('.fc-analytics-entries').hide();
    $('.fc-analytics-hide').hide();
    $('.fc-analytics-show').show();
  }

  function showAnalytics() {
    $('.fc-analytics-entries').show();
    $('.fc-analytics-hide').show();
    $('.fc-analytics-show').hide();
  }

  function showLogging() {
    const items = getItems();
    let markup = '';

    markup += '<div class="fc-analytics-window">';
    markup += '<div class="fc-analytics-buttons">';
    markup += '<button class="fc-analytics-clear">Clear Items</button>';
    markup += '<button class="fc-analytics-hide">Hide</button>';
    markup += '<button class="fc-analytics-show">Show</button>';
    markup += '</div>';
    markup += '<div class="fc-analytics-entries">';
    _.forEachRight(items, function(item) {
      markup += '<div class="fc-analytics-entry">';
      markup += '<div class="fc-analytics-event"><strong>Event:</strong> '+ item.event +'</div>';
      markup += '<div class="fc-analytics-properties"><strong>Properties:</strong> ';
      markup += '<pre>'+ JSON.stringify(item.properties, null, 2) +'</pre>';
      markup += '</div>';
      markup += '</div>';
    });

    markup += '</div>';
    markup += '</div>';

    $('body')
      .append(markup)
      .on('click.clear_analytics', '.fc-analytics-clear', clearItems)
      .on('click.hide_analytics', '.fc-analytics-hide', hideAnalytics)
      .on('click.show_analytics', '.fc-analytics-show', showAnalytics);
  }

  function track(event, properties) {
    setItem({
      event,
      properties: alphabetize(properties)
    });

    if ( _showLogging ) {
      updateEntries();
    }
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    clearItems,
    showLogging,
    track
  };
};

module.exports = Local_Analytics;
